import website from './website.png';
import github from './github.png';
import tumblr from './tumblr.png';
import yt from './yt(1).png';

const items = [
  {
    title: 'Portfolio',
    subtitle: 'Latest work!',
    image: website,
    link: 'https://domnorth.xyz/',
  },
  {
    title: 'GitHub',
    subtitle: '@monsieurverde | open-source projects',
    image: github,
    link: 'https://github.com/monsieurverde',
  },
  {
    title: 'Tumblr',
    subtitle: '@goodworkdom | mood archive',
    image: tumblr,
    link: 'https://goodworkdom.tumblr.com/',
  },
  {
    title: 'YouTube',
    subtitle: '@7dilla | Official channel',
    image: yt,
    link: 'https://www.youtube.com/@7dilla/featured',
  },
];

export default items;
